import _ from 'lodash'
import CompareMixin from '../components/filters/compare-mixin'
import { filters } from '../constants'
import { getComparisonLabel, reconciliationLabelFor } from './shared'

export const reconciliationResultDefinition = {
  type: filters.RECONCILIATION_RESULT,
  nameKey: 'reconciliation_result',
  ledgerRequired: true,

  comparisonModes() {
    return {
      number: CompareMixin.computed.numberComparisonModes(),
      text: CompareMixin.computed.textComparisonModes(),
      checkbox: CompareMixin.computed.booleanComparisonModes(),
      other: CompareMixin.computed.showAllComparisonMode(),
    }
  },

  activeSubtitle(settings, getters) {
    const { identifier, comparisonMode, comparisonValue } = settings
    const reconciliationName = reconciliationLabelFor(settings, getters)

    const flattenComparisonModes = _.flatten(_.values(this.comparisonModes()))
    const comparisonLabel = getComparisonLabel(
      comparisonMode,
      flattenComparisonModes
    )

    if (reconciliationName === undefined) {
      return ''
    }

    return `${reconciliationName}: ${identifier} ${comparisonLabel} ${comparisonValue}`
  },

  normalizeSettings(settings) {
    if (
      [
        CompareMixin.TYPES.SHOW_ALL,
        CompareMixin.TYPES.TRUE,
        CompareMixin.TYPES.FALSE,
      ].includes(settings.comparisonMode)
    ) {
      return {
        ...settings,
        comparisonValue: '',
      }
    }

    return settings
  },

  serializeSettings(settings) {
    return {
      comparison_mode: settings.comparisonMode,
      comparison_value: settings.comparisonValue,
      reconciliation_text_id: settings.reconciliationTextId,
      partner_reconciliation_text_id: settings.partnerReconciliationTextId,
      identifier: settings.identifier,
    }
  },

  deserializeSettings(params) {
    return {
      comparisonMode: params.comparison_mode,
      comparisonValue: params.comparison_value,
      reconciliationTextId: params.reconciliation_text_id,
      partnerReconciliationTextId: params.partner_reconciliation_text_id,
      identifier: params.identifier,
    }
  },
}
